export default __webpack_public_path__ + "static/media/loader.3bac1c30.gif";